import _ from 'lodash'
import {generateKey} from '../../mixins/keyGenerator'

export default {
  namespaced: true,

  state: {
    workspaceStates: {},
    current: null
  },

  getters: {
    workspaceStates: state => {
      return _.values(state.workspaceStates)
    },
    getWorkspaceStateById: (state) => (id) => {
      return _.get(state.workspaceStates, id, null)
    },
    getWorkspacesWithCurrentByFloorId: (state) => (floorId) => {
      return _.chain(state.workspaceStates)
        .filter(x => x.floorId === floorId && x.current)
        .map(x => {
          return x
        })
        .flatten()
        .uniq()
        .value()
    }
  },

  mutations: {
    updateWorkspaceStates(state, payload) {
      state.workspaceStates = payload.workspaceStates
    },
    clear(state) {
      state.calendars = {}
      state.workspaceStates = {}
      state.current = null
    },
    setCurrent(state, workspaceState) {
      state.current = workspaceState
    }
  },

  actions: {
    batchUpdate({commit, state}, batch) {
      const updatedWorkspaceStates = _.reduce(batch, (acc, data) => {
        const id = _.get(data, 'id', null)
        const commitType = _.get(data, 'commitType', null)
        const workspaceState = _.get(acc, id, {})
        _.set(workspaceState, 'id', id)
        _.set(workspaceState, 'name', _.get(data, 'name', null))
        _.set(workspaceState, 'type', _.get(data, 'type', null))
        _.set(workspaceState, 'key', generateKey())
        _.set(workspaceState, 'description', _.get(data, 'description', null))
        _.set(workspaceState, 'capacity', _.get(data, 'capacity', null))
        _.set(workspaceState, 'floorId', _.get(data, 'floorId', null))
        _.set(workspaceState, 'imageRelativeUrl', _.get(data, 'imageRelativeUrl', null))
        switch (commitType) {
          case 'calendar':
            const current = _.get(data, 'current', null)
            const next = _.get(data, 'next', null)
            const hasResource = _.get(data, 'hasResource', null)
            _.set(workspaceState, 'current', current)
            _.set(workspaceState, 'next', next)
            _.set(workspaceState, 'isReserved', current !== null)
            _.set(workspaceState, 'hasResource', hasResource)
            break
          case 'presence':
            const presence = _.get(data, 'state', null)
            _.set(workspaceState, 'presence', presence)
            break
          default:
            return
        }

        _.set(workspaceState, 'state', _.get(workspaceState, 'presence', 'None'))

        return {
          ...acc,
          [id]: workspaceState
        }
      }, state.workspaceStates)

      commit('updateWorkspaceStates', {workspaceStates: updatedWorkspaceStates})
    },
    clear({commit}) {
      commit('clear')
    },
    selectWorkspace({commit, state}, workspaceId) {
      const workspaceState = _.get(state.workspaceStates, workspaceId, null)
      commit('setCurrent', workspaceState)
    },
    clearSelectedWorkspace({commit}) {
      commit('setCurrent', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/workspaces.js